export const dedicatedSections = ['servers', 'users', 'ips', 'preorders', 'preorder/hardware'] as const
export type DedicatedServersSection = typeof dedicatedSections[number]

type MenuEntry = {
  main_feature?: string;
  feature?: string;
  angular_route?: string | null;
  items?: MenuEntry[];
}

type DedicatedMenu = { menu?: MenuEntry[] } | null | undefined

export const hasDedicatedServersAccess = (
  appMenu: DedicatedMenu,
  section: DedicatedServersSection,
): boolean => {
  const featureSuffix = section.replace(/\//g, '.')
  const features = ['dedicatedservers', 'dedicated_servers', 'dedicated-servers']
    .map((prefix) => `${prefix}.${featureSuffix}`)
  const route = `dedicated-servers/${section}`

  // A category or a sibling section does not grant access to every dedicated route.
  return appMenu?.menu?.some((category) => [category, ...(category.items || [])].some((item) => {
    const itemRoute = item.angular_route?.replace(/^\/+|\/+$/g, '')
    return features.includes(item.main_feature || '')
      || features.includes(item.feature || '')
      || itemRoute === route
      || itemRoute === `openstack/${route}`
  })) ?? false
}

export const getDefaultDedicatedSection = (appMenu: DedicatedMenu): DedicatedServersSection | undefined => (
  dedicatedSections.find((section) => hasDedicatedServersAccess(appMenu, section))
)
